// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2XfiM","select":"styles_select__13fpC"};